import { geminiPlugin } from './gemini';

export interface TitlePlugin {
  /** Human-readable name for debugging */
  name: string;
  /** Return true if this plugin should handle the given normalized URL */
  matches: (url: string) => boolean;
  /** Transform the title. Return the original title unchanged if no transformation is needed. */
  transform: (url: string, title: string) => string;
  /**
   * Return true if the given Chrome-reported title is a generic placeholder (e.g. just the app
   * name, not a real conversation title).  When true, effectiveTitle returns undefined so that
   * ensurePageTracked skips overwriting any previously-stored richer title in the DB.
   */
  isGeneric?: (title: string) => boolean;
}

// All active plugins — add new plugins here
const plugins: TitlePlugin[] = [geminiPlugin];

/**
 * Apply the first matching title plugin to the given URL + title.
 * Returns the (possibly transformed) title, or the original if no plugin matched.
 */
export function applyTitlePlugins(url: string, title: string): string {
  for (const plugin of plugins) {
    if (plugin.matches(url)) {
      return plugin.transform(url, title);
    }
  }
  return title;
}

/**
 * Return true if the Chrome-reported title for this URL is a known generic placeholder.
 * When true, callers should skip overwriting any richer title already stored in the DB.
 */
export function isChromeGenericTitle(url: string, title: string): boolean {
  for (const plugin of plugins) {
    if (plugin.matches(url) && plugin.isGeneric?.(title)) {
      return true;
    }
  }
  return false;
}
